<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招接待宾馆预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>宾馆基本信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" prop="pictures" label="宾馆图片">
          <template slot-scope="scope">
            <div class="commodity-name-style">
              <div class="commodity-wrap-img-style">
                <img :src="scope.row.pictures[0]" alt="" class="commodity-img-style" style="width: 100%" />
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="region" align="center" label="所属片区">
          <template slot-scope="scope">
            <span>{{ scope.row.region == 1 ? "对内" : "对外" }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="name" align="center" label="宾馆名称"> </el-table-column>

        <el-table-column prop="address" align="center" label="宾馆地址"> </el-table-column>

        <el-table-column prop="tel" align="center" label="联系电话"> </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="detailItem(scope.row.id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {},
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    detailItem: function (id) {
      this.$router.push({
        name: "roomManagementDetail",
        query: {
          id: id,
        },
      });
    },
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        name: "",
        page: this.pager.pageIndex,
        size: this.pager.pageSize,
      });
      this.$http({
        url: global.apiUrl + "/reception/hotel/list",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data && res.body.data.data.length > 0) {
              this.tableData = res.body.data.data;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>
<style>
#convalescenceInfoTable {
  width: 100%;
}
#convalescenceInfoTable th {
  font-weight: normal;
  text-align: left;
  font-size: 14px;
}
#convalescenceInfoTable td {
  font-size: 14px;
}
</style>
